import sagas from './sagas';

const applicantsModule = {
  sagas
};

export default applicantsModule;
